import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBuilderColors } from "../../../../redux/slices/linksBuilder";
import { Col, Row } from "react-bootstrap";
import LinkListColorPicker from "../linkListColorPicker";
import ColorPaletteItem from "./ColorPaletteItem";
import classNames from "classnames";
import NoColorPaletteItem from "./NoColorPaletteItem";
import { FrameItem } from "./SocialLinks";

export const colorPalettes = [
  {
    id: 1,
    background: "#FBFBFB",
    linkBackground: "#F5F5F5",
    textColor: "#3E4957",
  },
  {
    id: 2,
    background: "#596175",
    linkBackground: "#313A52",
    textColor: "#FFFFFF",
  },
  {
    id: 3,
    background: "#786FA6",
    linkBackground: "#6859B8",
    textColor: "#FFFFFF",
  },
  {
    id: 4,
    background: "#778CEB",
    linkBackground: "#566EE7",
    textColor: "#FFFFFF",
  },
  {
    id: 5,
    background: "#3EC1D2",
    linkBackground: "#65CDDC",
    textColor: "#FFFFFF",
  },
  {
    id: 6,
    background: "#BBE3B4",
    linkBackground: "#97D58D",
    textColor: "#FFFFFF",
  },
  {
    id: 7,
    background: "#F7D694",
    linkBackground: "#F4CD7B",
    textColor: "#FFFFFF",
  },
  {
    id: 8,
    background: "#F3A683",
    linkBackground: "#F48D5F",
    textColor: "#FFFFFF",
  },
  {
    id: 9,
    background: "#EF9079",
    linkBackground: "#E26141",
    textColor: "#FFFFFF",
  },
  {
    id: 10,
    background: "#F8A6C1",
    linkBackground: "#F78FB2",
    textColor: "#FFFFFF",
  },
  {
    id: 11,
    background: "#f26d9a",
    linkBackground: "#f14f85",
    textColor: "#FFFFFF",
  },
];

export default function Design() {
  const { lang, colors } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo.linkList,
    colors: state.linksBuilder.data.colors,
  }));

  const dispatch = useDispatch();

  const isSelectedPallete = (item) =>
    item.background === colors[0] &&
    item.linkBackground === colors[1] &&
    item.textColor === colors[2];

  return (
    <>
      <div className="fw-bold fs-4 mb-3 mb-md-4">{lang[0]}</div>
      <div className="fw-bold fs-5 mb-3">{lang[31]}</div>
      <Row className="g-3">
        <NoColorPaletteItem />
        {colorPalettes.map((item) => {
          return (
            <Col xs={2} md={1} key={item.id}>
              <FrameItem
                onClick={() =>
                  dispatch(
                    setBuilderColors([
                      item.background,
                      item.linkBackground,
                      item.textColor,
                    ])
                  )
                }
                className={classNames(
                  "d-flex justify-content-center align-items-center border rounded-1 p-2",
                  {
                    "border-primary": isSelectedPallete(item),
                    "border-border-gray": !isSelectedPallete(item),
                  }
                )}
              >
                <ColorPaletteItem
                  background={item.background}
                  linkBackground={item.linkBackground}
                  textColor={item.textColor}
                />
              </FrameItem>
            </Col>
          );
        })}
      </Row>

      <div className="fw-bold fs-5 mb-3 mt-4">{lang[32]}</div>
      <Row>
        <Col xs={4}>
          <LinkListColorPicker title={lang[1]} numberColor={0} />
        </Col>
        <Col xs={4}>
          <LinkListColorPicker title={lang[2]} numberColor={1} />
        </Col>
        <Col xs={4}>
          <LinkListColorPicker title={lang[3]} numberColor={2} />
        </Col>
      </Row>
    </>
  );
}
